import '@/bootstrap';

window.api = process.env.VUE_APP_LUDUM_API_URL;

import global from '@/mixins/global';
import i18n from '@/lang/index';
import router from './router';
import store from './store/index';
import './registerServiceWorker';
import './third-parties/mixpanel.js';
import './third-parties/intercom.js';
import Auth from '@/packages/auth/Auth';
import App from './App.vue';
import LoadScript from 'vue-plugin-load-script';
import Meta from 'vue-meta';
import VueClipboard from 'vue-clipboard2';
import VueCookie from 'vue-cookie';
import VueDatetime from 'vue-datetime';
import VueSweetAlert from 'vue-sweetalert';

Vue.use(Auth);
Vue.use(LoadScript);
Vue.use(Meta);
Vue.use(VueClipboard);
Vue.use(VueCookie);
Vue.use(VueDatetime);
Vue.use(VueSweetAlert);

Vue.mixin(global);

Vue.config.productionTip = false;

export default new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app');
